
<template>
  <div>
    <table class="table table-striped w-100" v-if="admins.length > 0">
      <thead>
        <tr>
          <th>Sl.No</th>
          <th>Name</th>
          <th>Username</th>
          <th>User Id</th>
          <th>Remove</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(admin,index) in admins" :key="index">
          <td>{{index+1}}</td>
          <td>{{ admin.first_name }} {{admin.last_name}}</td>
          <td><a :href="'https://t.me/'+admin.username" target="blank">{{ admin.username }}</a></td>
          <td>{{ admin.id }}</td>
          <td>
            <button @click="$emit('deleteAdmin',admin.id)" class="btn btn-outline-danger btn-sm">Remove</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="alert alert-info" role="alert" v-else>
      <strong>Info!</strong> No admins found. Please start the bot in Telegram if you have not yet started.
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminCard',
  props:{
    admins: Array
  },
}

</script>
